'use strict';

import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import {createStore} from 'state-pool';
import esriMap from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import Graphic from "@arcgis/core/Graphic"
import Polygon from "@arcgis/core/geometry/Polygon"
import HomeWidget from "@arcgis/core/widgets/Home"
import Utils from '../../../shared/utils';
import ConfigService from '../../../shared/configService';
import {useTranslation} from "react-i18next";
import { IFeature } from "@esri/arcgis-rest-types";
import { ToastContainer } from 'react-toastify';
import { IDashboard } from '../../../models/IConfig';
import { IReportMain } from '../../../models/IConfig';
import { useHistory } from "react-router-dom";
import DashboardUtils from "../dashboardUtils"

const store = createStore();
store.setState("mapview", null);
  

export const MapArea = forwardRef((props: any, ref) => {

  const history = useHistory();  
  const mapAreaRef = React.createRef<HTMLDivElement>();
  const reportMainConfig: IReportMain = ConfigService.getConfig().agol.operationalLayers.reportMain;
  const dashboardConfig: IDashboard  = ConfigService.getConfig().dashboard;
  const [mapview, setMapview] = store.useState("mapview");
  
  /**
   * Data state
   */
   interface IDataState {
    popupAreaCountry?: any;
    popupAreaState?: any;
    map:esriMap;
    countriesGraphics: Graphic[],
    statesGraphics: Graphic[]
  }

  useImperativeHandle(ref, () => ({
    zoomToCountryOrState,
    goToInitialExtent
  }));

  const {t} = useTranslation('dashboard');
  
  /*let countriesGraphics:Graphic[];
  let statesGraphics:Graphic[];*/

  /**
   * Component state
   */
  const [dataState, setDataState] = useState<IDataState>({
    
    // popupAreaCountry: {
    //   title: dashboardConfig.map.countriesLayer.popupArea.title,
    //   content: [{
    //     type: "fields",
    //     fieldInfos: dashboardConfig.map.countriesLayer.popupArea.fieldsInfos
    //   }]
      
    // },
    // popupAreaState: {
    //   title:  dashboardConfig.map.statesLayer.popupArea.title,
    //   content: [{
    //     type: "fields",
    //     fieldInfos:  dashboardConfig.map.statesLayer.popupArea.fieldsInfos
    //   }],
    // },
    map: new esriMap({
      basemap: "topo",
    }),
    countriesGraphics: [],
    statesGraphics: []
  });

  useEffect(() => {   
     
    loadMap(props);
    
    loadGraphics();

  }, []);


const onSelectedFeature = (gid:string) => {
  props.onSelectedFeature(gid);
}

  
  const loadGraphics = async () => {
    
    const countriesGraphics = props.countries.map( (feature:IFeature) => {
      const geometry = new Polygon({
        rings: (feature.geometry as any)?.rings
      });
      return new Graphic({
        attributes: feature.attributes,
        geometry: geometry
      });
    });
    Utils.setStateValue("countriesGraphics", countriesGraphics, dataState, setDataState);

    const statesGraphics = props.states.map( (feature:IFeature) => {
      const geometry = new Polygon({
        rings: (feature.geometry as any)?.rings
      });
      return new Graphic({
        attributes: feature.attributes,
        geometry: geometry
        
      });
    });
    Utils.setStateValue("statesGraphics", statesGraphics, dataState, setDataState);

    if(countriesGraphics && countriesGraphics.length > 0) {
      const fLayerCountries = new FeatureLayer({
        source: countriesGraphics,  // array of graphics objects
        objectIdField: "OBJECTID",
        fields: dashboardConfig.map.countriesLayer.fields as any[],
        popupTemplate: dataState.popupAreaCountry,
        renderer: {
          type: "simple",  // autocasts as new SimpleRenderer()
          symbol: {
            type: "simple-fill", 
            color: dashboardConfig.map.countriesLayer.symbol.fillColor,
            outline: {  
              width: dashboardConfig.map.countriesLayer.symbol.outline.width,
              color: dashboardConfig.map.countriesLayer.symbol.outline.color
            }
          }
        } as any
      });
      dataState.map.add(fLayerCountries);
      
    }

    if(statesGraphics && statesGraphics.length > 0) {
      const fLayerStates = new FeatureLayer({
        source: statesGraphics,  // array of graphics objects
        objectIdField: "OBJECTID",
        fields: dashboardConfig.map.statesLayer.fields as any[],
        popupTemplate: dataState.popupAreaState,
        renderer: {
          type: "simple",  
          symbol: {
            type: "simple-fill",  
            color: dashboardConfig.map.statesLayer.symbol.fillColor,
            outline: {  
              width: dashboardConfig.map.statesLayer.symbol.outline.width,
              color: dashboardConfig.map.statesLayer.symbol.outline.color
            }
          }
        } as any
      });
      dataState.map.add(fLayerStates);
    }

    
    store.getState("mapview").value.on("click", function(event:any){
      store.getState("mapview").value.hitTest(event)
        .then(function(response:any){
            // do something with the result graphic
            if(response.results && response.results.length > 0) {
              const graphic = response.results[0].graphic;
              zoomToGraphic(graphic);
            }
            else {
              onSelectedFeature("");  
            }
           
        });
    });

  }

  const goToInitialExtent = () => {
    store.getState("mapview").value.popup.close();
    store.getState("mapview").value.goTo({
      center: dashboardConfig.map.center,
      zoom: dashboardConfig.map.defaultZoomLevel,
    });
  }

  const zoomToGraphic = (graphic:Graphic) => {

    let countryGraphic = props.countries.find( (country:any) => country.attributes["OBJECTID"] == graphic.attributes["OBJECTID"]);
    let stateGraphic = props.states.find( (state:any) => state.attributes["OBJECTID"] == graphic.attributes["OBJECTID"]);
    if(stateGraphic) {
      stateGraphic = new Graphic({
        attributes: stateGraphic.attributes,
        geometry: new Polygon({
          rings: (stateGraphic.geometry as any)?.rings
        })
      });
      onSelectedFeature(stateGraphic.attributes[reportMainConfig.fields.gid1])
      store.getState("mapview").value.goTo(stateGraphic.geometry);
    } else if(countryGraphic) {
      countryGraphic = new Graphic({
        attributes: countryGraphic.attributes,
        geometry: new Polygon({
          rings: (countryGraphic.geometry as any)?.rings
        })
      });
      onSelectedFeature(countryGraphic.attributes[reportMainConfig.fields.gid0])
      store.getState("mapview").value.goTo(countryGraphic.geometry);
    } else
      onSelectedFeature("");
    
  }

  const zoomToCountryOrState = (gid:string) => {
    //alert(label);
    let countryGraphic = null; 
    let stateGraphic = null;
    let poly:Polygon;
    let graphic:Graphic;
    
    if(props.countries)
      countryGraphic = props.countries.find( (country:any) => country.attributes[reportMainConfig.fields.gid0] == gid);
    if(props.states)
      stateGraphic = props.states.find( (state:any) => state.attributes[reportMainConfig.fields.gid1] == gid);

      if(stateGraphic) {
        poly = new Polygon({
          rings: (stateGraphic.geometry as any)?.rings
        });
        graphic = new Graphic({
          attributes: stateGraphic.attributes,
          geometry: poly          
        });
        stateGraphic.popupTemplate = new PopupTemplate(dataState.popupAreaState);
        store.getState("mapview").value.popup.open({
          features: [stateGraphic],
          location: poly.centroid
        });
        //store.getState("mapview").value.goTo(stateGraphic);
      } else if(countryGraphic) {
        poly = new Polygon({
          rings: (countryGraphic.geometry as any)?.rings
        });
        graphic = new Graphic({
          attributes: countryGraphic.attributes,
          geometry: poly          
        });
        countryGraphic.popupTemplate = new PopupTemplate(dataState.popupAreaCountry);
        store.getState("mapview").value.popup.open({
          features: [countryGraphic],
          location: poly.centroid
        });
        //store.getState("mapview").value.center = [-92.8623580901537,15.1681938195891]
        //store.getState("mapview").value.goTo(countryGraphic.geometry);
      } else {
        onSelectedFeature(""); 
        return;
      } 

      if(graphic) {
        //var screenPoint = store.getState("mapview").value.toScreen(poly.centroid);
        zoomToGraphic(graphic);
        
      }
  }
  const loadMap = async (props: any) => {
     let selLocation:number [] = dashboardConfig.map.center;
    let zooming:number =5;

    // if(props.countries.length > 0)
    // {
    //   selLocation =[props.countries[0].geometry.rings[0][0][0],props.countries[0].geometry.rings[0][0][1]];
    //   if(props.countries[0].attributes.Shape__Area > 100 || props.countries[0].attributes.Shape__Length >80)
    //   {
    //     zooming=3;
    //   }
    //   if(props.countries[0].attributes.Shape__Area > 35 && props.countries[0].attributes.Shape__Area < 100 && props.countries[0].attributes.Shape__Length < 80)
    //   {
    //     zooming=4;
    //   }
    //   if(props.countries[0].attributes.Shape__Area < 9)
    //   {
    //     zooming=7;
    //   }
    // }
    // else if(props.states.length > 0)
    // {
    //   selLocation =[props.states[0].geometry.rings[0][0][0],props.states[0].geometry.rings[0][0][1]];
    // }
    
    const mv = new MapView({
      container:"mapAreaRef",
      map: dataState.map,
      highlightOptions: dashboardConfig.map.highlightOptions,
      //center: selLocation,
      //zoom: zooming,
      center: dashboardConfig.map.center,
      zoom: dashboardConfig.map.defaultZoomLevel,
      constraints: { minZoom:dashboardConfig.map.minZoomLevel, maxZoom: dashboardConfig.map.maxZoomLevel  } 
     
    
    });
    //dataState.map.on("load", function (alert('laoded')){});
    store.setState("mapview", mv);
    
    //Utils.setStateValue("mapview", mapview, dataState, setDataState);
    
    const homeWidget = new HomeWidget({
      view: store.getState("mapview").value
    });
    
    // Add the home button to the top left corner of the view
    store.getState("mapview").value.ui.add(homeWidget, "top-left");
    
    store.getState("mapview").value.when(() => {
      const popup = store.getState("mapview").value.popup;
      console.log(popup);
      popup.viewModel.on("trigger-action", (event:any) => {
        if (event.action.id === "details") {
          const oid:number = popup.selectedFeature.attributes[reportMainConfig.fields.objectid];
          let graphic:Graphic | undefined = DashboardUtils.chooseStateOrCountryGraphic(props.states, props.countries, oid)
          //let graphic:Graphic = props.states.find( (state:Graphic) => state.attributes[reportMainConfig.fields.objectid] == oid);
          
          let gid:string = graphic?.attributes["gid"];
          const year = popup.selectedFeature.attributes[reportMainConfig.fields.repYear];
          //console.log(gid + ", " + year);
          props.onShowDetails(gid, year);
          //history.push(ConfigService.getConfig().routes?.detaildashboard || '');
        }
      });
    });

  }

  return (
    <div>
      {dataState.countriesGraphics && dataState.statesGraphics &&
        <div className="webmap" id="mapAreaRef" ref={mapAreaRef} />
      }

      <ToastContainer 
            position="bottom-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover/>

    </div>
    );

});
